import Loadable from 'react-loadable';
import LoadingIndicator from 'components/LoadingIndicator';

export default Loadable({
  loader: () =>
    import(
      '../AcquisitionPartnerNonServ' /* webpackChunkName: "Acquisition Partner NonServ" */
    ),
  loading: LoadingIndicator,
});
